"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=storage-item.interface.js.map